/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-16 18:09:56
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2021-11-24 18:17:04
 * @Description: 
 */

export default {
    protocol: "",
    domain: "",
    action: {
      actIp: "act=ip",  //浏览记录
      actShare: "act=share",  //分享
      actEntry: "act=entry",   //留电
      actUserEvent: "act=uevent",   //用户事件
    }
  }